import './index.scss'

const LoadingPage = () => {
    return (
        <div id="loading-indicator">
            <div className="lds-hourglass"></div>
        </div>
    )
}

export default LoadingPage